<script>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref } from "vue";
import { onMounted } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";

export default {
  data() {
    return {
      title: "Candidates",
      text: "Administration",
      text1: "Candidates Grid",
    };
  },
  methods: {
    toggleHeader() {
      document.getElementById("collapse-header").classList.toggle("active");
      document.body.classList.toggle("header-collapse");
    },
  },
  setup() {
    const dateRangeInput = ref(null);

    // Move the function declaration outside of the onMounted callback
    function booking_range(start, end) {
      return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
    }

    onMounted(() => {
      if (dateRangeInput.value) {
        const start = moment().subtract(6, "days");
        const end = moment();

        new DateRangePicker(
          dateRangeInput.value,
          {
            startDate: start,
            endDate: end,
            ranges: {
              Today: [moment(), moment()],
              Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
              "Last 7 Days": [moment().subtract(6, "days"), moment()],
              "Last 30 Days": [moment().subtract(29, "days"), moment()],
              "This Month": [moment().startOf("month"), moment().endOf("month")],
              "Last Month": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
              ],
            },
          },
          booking_range
        );

        booking_range(start, end);
      }
    });

    return {
      dateRangeInput,
    };
  },
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div class="me-2 mb-2">
            <div class="d-flex align-items-center border bg-white rounded p-1 me-2">
              <router-link
                to="/recuritment/candidates-kanban"
                class="btn btn-icon btn-sm me-1"
                ><i class="ti ti-layout-kanban"></i
              ></router-link>
              <router-link to="/recuritment/candidates" class="btn btn-icon btn-sm me-1"
                ><i class="ti ti-list-tree"></i
              ></router-link>
              <router-link
                to="/recuritment/candidates-grid"
                class="btn btn-icon btn-sm active bg-primary text-white"
                ><i class="ti ti-layout-grid"></i
              ></router-link>
            </div>
          </div>
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              class=""
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="card">
        <div class="card-body p-3">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
          >
            <h5>Candidates Grid</h5>
            <div class="d-flex align-items-center flex-wrap row-gap-3">
              <div class="me-3">
                <div class="input-icon-end position-relative">
                  <input
                    type="text"
                    class="form-control date-range bookingrange"
                    ref="dateRangeInput"
                    placeholder="dd/mm/yyyy - dd/mm/yyyy"
                  />
                  <span class="input-icon-addon">
                    <i class="ti ti-chevron-down"></i>
                  </span>
                </div>
              </div>
              <div class="dropdown me-3">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Role
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1"
                      >Accountant</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1"
                      >App Developer</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1"
                      >Technician</a
                    >
                  </li>
                </ul>
              </div>
              <div class="dropdown me-3">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Select Status
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1"
                      >Select Status</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1"
                      >Active</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1"
                      >Inactive</a
                    >
                  </li>
                </ul>
              </div>
              <div class="dropdown">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Sort By : Last 7 Days
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1"
                      >Recently Added</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1"
                      >Ascending</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1"
                      >Desending</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1"
                      >Last Month</a
                    >
                  </li>
                  <li>
                    <a href="javascript:void(0);" class="dropdown-item rounded-1"
                      >Last 7 Days</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Candidates Grid -->
      <div class="row">
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-39.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >Harold Gaynor</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-001</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">harold@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">Accountant</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-purple">
                    <i class="ti ti-point-filled"></i> New</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-40.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >Sandra Ornellas</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-002</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">sandra@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">Accountant</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-pink">
                    <i class="ti ti-point-filled"></i> Scheduled</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-41.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >John Harris</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-003</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">john@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">Technician</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-info">
                    <i class="ti ti-point-filled"></i> Interviewed</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-42.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >Carole Langan</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-004</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">carole@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">Web Developer</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-warning">
                    <i class="ti ti-point-filled"></i> Offered</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-44.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >Charles Marks</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-005</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">charles@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">SEO</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-success">
                    <i class="ti ti-point-filled"></i> Hired</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-43.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >Kerry Drake</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-006</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">kerry@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">Designer</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-danger">
                    <i class="ti ti-point-filled"></i> Rejected</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-46.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >David Carmona</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-007</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">david@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">Account Manager</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-success">
                    <i class="ti ti-point-filled"></i> Hired</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-45.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >Margaret Soto</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-008</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">margaret@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">SEO Analyst</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-pink">
                    <i class="ti ti-point-filled"></i> Scheduled</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-48.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >Jeffrey Thaler</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-009</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">jeffrey@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">Admin</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-purple">
                    <i class="ti ti-point-filled"></i> New</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-47.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >Joyce Golston</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-010</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">joyce@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">Business Analyst</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-success">
                    <i class="ti ti-point-filled"></i> Hired</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-49.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >Cedric Rosalez</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-011</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">cedric@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">Financial Analyst</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-purple">
                    <i class="ti ti-point-filled"></i> New</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-md-6">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center flex-shrink-0">
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-lg avatar rounded-circle me-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#candidate_details"
                  >
                    <img
                      src="@/assets/img/users/user-50.jpg"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </a>
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-wrap mb-1">
                      <h6 class="fs-16 fw-semibold me-1">
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#candidate_details"
                          >Lillie Diaz</a
                        >
                      </h6>
                      <span class="badge bg-primary-transparent">Cand-012</span>
                    </div>
                    <p class="text-gray fs-13 fw-normal">lillie@example.com</p>
                  </div>
                </div>
              </div>
              <div class="bg-light rounder p-2">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Role</h6>
                  <span class="text-dark fs-14 fw-medium">Receptionist</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h6 class="text-gray fs-14 fw-normal">Applied Date</h6>
                  <span class="text-dark fs-14 fw-medium">12 Sep 2024</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="text-gray fs-14 fw-normal">Status</h6>
                  <span class="fs-10 fw-medium badge bg-danger">
                    <i class="ti ti-point-filled"></i> Rejected</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="text-center mb-4">
            <a href="javascript:void(0);" class="btn btn-primary"
              ><i class="ti ti-loader-3 me-1"></i>Load More</a
            >
          </div>
        </div>
      </div>
      <!-- /Candidates Grid -->
    </div>
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - 2025 &copy; SmartHR.</p>
      <p>
        Designed &amp; Developed By
        <a href="javascript:void(0);" class="text-primary">Dreams</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <candidates-grid-modal></candidates-grid-modal>
</template>
